import { Budget } from "../types";
import { getStatusStyles, getBorderColor } from "./utils";
import CardHeader from "./components/CardHeader";
import CardDetails from "./components/CardDetails";
import CardActions from "./components/CardActions";
import useDarkMode from "../../../hooks/useDarkMode";

interface BudgetCardProps {
  budget: Budget;
  onViewHistory?: (budgetId: string) => void;
  onAction?: (budgetId: string, action: string) => void;
}

const BudgetCard = ({ budget, onViewHistory, onAction }: BudgetCardProps) => {
  const isDarkMode = useDarkMode();
  const styles = getStatusStyles(budget.status);
  const borderColor = getBorderColor(budget.status, isDarkMode);

  return (
    <div className="p-[10px] !h-auto w-full bg-[#D0DAE2] dark:bg-neutral-800">
      <div
        className={`w-full border rounded-lg p-4 flex flex-col justify-between ${styles.cardBg} ${styles.border} text-size-14 text-gray-800 dark:text-neutral-200`}
        style={{
          height: "220px",
          borderWidth: "1.7px",
          borderColor: borderColor,
        }}
      >
        <div>
          <CardHeader budgetNumber={budget.budgetNumber} version={budget.version} />
          <CardDetails recipient={budget.recipient} date={budget.date} vehicleChassis={budget.chassis} customerName={budget.customerName} />
        </div>

        <CardActions
          budget={budget}
          onViewHistory={onViewHistory}
          onAction={onAction}
          buttonBg={styles.buttonBg}
          buttonText={styles.buttonText}
          buttonHover={styles.buttonHover}
        />
      </div>
    </div>
  );
};

export default BudgetCard;



